/* eslint-disable no-restricted-imports */
import { MouseEventHandler } from 'react';

import * as toastify from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast-overrides.css';

function CloseButton({
  closeToast = () => {},
}: {
  closeToast?: MouseEventHandler<HTMLButtonElement>;
}) {
  return (
    <button type="button" onClick={closeToast} className="icon_btn">
      <i
        data-testid="Toast_close"
        className="ToggleToast-close fas fa-times"
        style={{ fontSize: '1rem' }}
      />
    </button>
  );
}

export default function Toaster({
  ...props
}: Partial<toastify.ToastContainerProps> = {}) {
  return (
    <toastify.ToastContainer
      className="ToastContainer"
      toastClassName="ToggleToast"
      position={toastify.toast.POSITION.TOP_CENTER}
      closeButton={<CloseButton />}
      autoClose={3000}
      draggable={false}
      {...props}
    />
  );
}

export * from 'react-toastify';
